import React from 'react';
import Button from '../shared/Button';
import Icon from '../shared/Icon';
import PhoneFrame from './PhoneFrame';
import { MOCK_FEED, MOCK_LOGS, MOCK_WORKOUTS } from '../../utils/mockData';
import { formatWorkOutput } from '../../utils/engineStub';
import homeShot from '../../assets/img/screenshot-home.png';
import exerciseShot from '../../assets/img/screenshot-exercise-record.png';
import scheduleShot from '../../assets/img/screenshot-schedule-preview.png';
import ratingShot from '../../assets/img/screenshot-fitndex-rating.png';
import './SplashModal.css';

const prMoment = MOCK_FEED.find((f) => f.type === 'pr');
const loggedMoment = MOCK_LOGS[MOCK_LOGS.length - 1];
const loggedWorkout = MOCK_WORKOUTS.find((w) => w.id === loggedMoment.workoutId);

const HERO_SCREENS = [
  { src: homeShot, alt: 'FITNDEX home screen' },
  { src: exerciseShot, alt: 'FITNDEX exercise record detail' },
  { src: scheduleShot, alt: 'FITNDEX weekly schedule preview' },
  { src: ratingShot, alt: 'FITNDEX athlete rating breakdown' },
];

export default function SplashModal({ onLearnMore, onJoinWaitlist, onBetaAccess, isLeaving }) {
  return (
    <div className="splash-modal-wrap">
      <div className="splash-modal__stage">
        <div className="splash-modal anim-fade-in-scale">
          <div className="splash-modal__kicker-pill">
            <span className="splash-modal__platforms" aria-hidden="true">
              <Icon name="apple" size={16} />
              <Icon name="android" size={16} />
              <Icon name="windows" size={16} />
            </span>
            Coming Soon
          </div>

          <div className="splash-modal__eyebrow">
            <span>Build.</span>
            <span>Measure.</span>
            <span>Perform.</span>
          </div>
          <p className="splash-modal__tagline">
            Every rep. Every session. <br className="splash-modal__tagline-break" /><strong>One objective athlete score.</strong>
          </p>

          <div className="splash-modal__actions">
            <Button variant="primary" size="lg" className="splash-modal__cta anim-shimmer" onClick={onLearnMore}>
              Explore FITNDEX
            </Button>
          </div>
          <div className="splash-modal__secondary-links">
            <button type="button" onClick={onJoinWaitlist}>Join Waitlist</button>
            <span aria-hidden="true">·</span>
            <button type="button" onClick={onBetaAccess}>Beta Tester</button>
          </div>
        </div>

        <div className="splash-modal__phone-stage">
          <PhoneFrame images={HERO_SCREENS} size="xl" tilt={-2} clickable={false} fadeBottom />

          <div className="splash-modal__float-card splash-modal__float-card--notif">
            <span className="splash-modal__float-badge">Streak</span>
            <span className="splash-modal__float-text">You're on a 12-day training streak</span>
            <span className="splash-modal__float-metric">12 days</span>
          </div>

          <div className="splash-modal__float-card splash-modal__float-card--pr">
            <span className="splash-modal__float-badge">PR</span>
            <span className="splash-modal__float-text">You hit a new PR — Deadlift 245 lbs</span>
            <span className="splash-modal__float-metric">{formatWorkOutput(prMoment.workOutput)}</span>
          </div>

          <div className="splash-modal__float-card splash-modal__float-card--log">
            <span className="splash-modal__float-badge">Logged</span>
            <span className="splash-modal__float-text">You completed {loggedWorkout.name}</span>
            <span className="splash-modal__float-metric">{formatWorkOutput(loggedMoment.workOutputAchieved)}</span>
          </div>
        </div>
      </div>

      <div className="splash-modal__note">For individuals and teams.</div>
      <footer className={`splash-modal__footer${isLeaving ? ' splash-modal__footer--leaving' : ''}`}>
        <span>United States · Copyright © 2026 FITNDEX LLC. All rights reserved.</span>
        <span className="splash-modal__footer-links">
          <a href="/privacy">Privacy Policy</a>
          <span aria-hidden="true">|</span>
          <a href="/terms">Terms of Use</a>
        </span>
      </footer>
    </div>
  );
}
